const commentItems = [
  {
    name: '资深瓜友',
    role: '5年吃瓜群众',
    content: '全网最刚的吃瓜平台没有之一！别的地方都是通稿洗白，只有这里敢放真料。那个顶流的酒店视频我看了三遍，太刺激了。每天凌晨蹲更新已经成了习惯，比追剧还上头。',
  },
  {
    name: '娱乐圈老司机',
    role: '前娱乐记者',
    content: '作为曾经在娱乐媒体干了八年的人，我可以负责任地说，这里的爆料深度远超很多所谓"权威媒体"。很多内幕我在业内都只听过风声，这里直接放实锤，respect！',
  },
  {
    name: '吃瓜不嫌事大',
    role: '忠实用户',
    content: '朋友推荐来的，一开始以为是标题党，结果点进去发现每一条都有理有据。传送门的设计太赞了，重要爆料不会错过。现在我已经安利了整个办公室的同事，午休时间集体吃瓜。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          💬 瓜友热评
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>

              <div className="mb-4">
                <i className="ri-double-quotes-l text-3xl text-primary-300 w-8 h-8 flex items-center justify-center"></i>
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}